import { FOAccountMasterlistInterface } from '@modules/front-office/interface/fo-api-interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type FOBookingAccountsListTypeInterface =
  FOAccountMasterlistInterface['data']['properties'][0]['property']['accounts'][0]['account'][];

const initialState: FOBookingAccountsListTypeInterface = [];

export const FOBookingAccountsListType = createSlice({
  name: 'foBookingAccountsList',
  initialState,
  reducers: {
    setFOBookingAccountsList: (
      _state,
      action: PayloadAction<FOBookingAccountsListTypeInterface>,
    ) => {
      return [...action.payload];
    },
    removeFOBookingAccountsList: () => {
      return initialState;
    },
  },
});

export default FOBookingAccountsListType.reducer;

export const { setFOBookingAccountsList, removeFOBookingAccountsList } =
  FOBookingAccountsListType.actions;
